import { getStore } from 'src/App';
import actions from 'src/redux/actions';

export const messageSuccess = (message, duration) => {
  getStore().dispatch(actions.alertMessageSuccess({ message, duration }));
};
export const messageError = (message, duration) => {
  getStore().dispatch(actions.alertMessageError({ message, duration }));
};
